export default __webpack_public_path__ + "static/media/04_DAIF_Infra_02.8ec764c7.mp4";